module.exports = __webpack_public_path__ + "img/mount3.cb49522e.jpg";